package com.kinoshazam.screens.rootFlow

import androidx.navigation.NavBackStackEntry
import androidx.navigation.NavDestination.Companion.hasRoute
import androidx.navigation.toRoute
import com.kinoshazam.model.Route

internal data class AnalyticsScreen(
    val name: String,
    val properties: Map<String, Any?> = emptyMap(),
)

internal fun analyticsScreen(
    modalEntry: NavBackStackEntry?,
    mainEntry: NavBackStackEntry?,
): AnalyticsScreen? =
    screenOf(modalEntry) ?: screenOf(mainEntry)

private fun screenOf(entry: NavBackStackEntry?): AnalyticsScreen? {
    val destination = entry?.destination ?: return null
    return when {
        destination.route == "empty" -> null
        destination.hasRoute<Route.Main>() -> AnalyticsScreen("main")
        destination.hasRoute<Route.AllVideo>() -> {
            val route = entry.toRoute<Route.AllVideo>()
            AnalyticsScreen(
                name = "all_video",
                properties = mapOf(
                    "screen_type" to route.screenType,
                    "genre" to route.genre,
                    "person_id" to route.personId,
                ),
            )
        }
        destination.hasRoute<Route.AppInfo>() -> AnalyticsScreen("app_info")
        destination.hasRoute<Route.History>() -> AnalyticsScreen("watch_history")
        destination.hasRoute<Route.Update>() -> AnalyticsScreen("update")
        destination.hasRoute<Route.VideoPlayer>() -> AnalyticsScreen(
            name = "player",
            properties = mapOf("source" to "native"),
        )
        destination.hasRoute<Route.Dialog.Details>() -> {
            val route = entry.toRoute<Route.Dialog.Details>()
            AnalyticsScreen(
                name = "details",
                properties = mapOf(
                    "video_id" to route.id,
                    "is_serial" to route.isSerial,
                ),
            )
        }
        destination.hasRoute<Route.Dialog.WebPlayer>() -> AnalyticsScreen(
            name = "player",
            properties = mapOf("source" to "web_embed"),
        )
        destination.hasRoute<Route.Dialog.Search>() -> AnalyticsScreen("search")
        destination.hasRoute<Route.Dialog.Login>() -> AnalyticsScreen("login")
        destination.hasRoute<Route.Dialog.OtpScreen>() -> AnalyticsScreen("otp")
        destination.hasRoute<Route.Dialog.Profile>() -> AnalyticsScreen("profile")
        destination.hasRoute<Route.Dialog.ChangePassword>() -> AnalyticsScreen("change_password")
        destination.hasRoute<Route.Dialog.ForgotPassword>() -> AnalyticsScreen("forgot_password")
        destination.hasRoute<Route.Dialog.Decide>() -> AnalyticsScreen("decide")
        destination.hasRoute<Route.Dialog.Person>() -> {
            val route = entry.toRoute<Route.Dialog.Person>()
            AnalyticsScreen(
                name = "person",
                properties = mapOf("person_id" to route.personId),
            )
        }
        else -> null
    }
}
